export const ERROR404 = {
    ALT: '404 error. Page not found',
    TEXT1: 'Oops...',
    TEXT2: `We can't seem to find the page you are looking for.`
}